import { Col, DatePicker, Modal, Row } from "antd";
import React, { useEffect } from "react";
import TranslateText from "../TranslateText";
import InputSearchBox from "../Input/InputSearchBox";
import BaseButton from "../Button/BaseButton";
import { useDispatch } from "react-redux";
import SelectValue from "../Selector/SelectValue";
import { timeSelectSort } from "../../../utils/ValueSelect";
import { useState } from "react";
import moment from "moment";
import { IconXmark } from "../../../assets/icon";

const HeaderSort = ({
  setValueSearch,
  setConfig,
  config,
  title,
  handleExport,
}) => {
  const dispatch = useDispatch();
  const dateFormat = "DD/MM/YYYY";
  const [isSelectTime, setIsSelectTime] = useState(false);
  const [timeSelect, setTimeSelect] = useState({
    type: 0,
    timeStart: "",
    timeEnd: "",
  });
  const startTime = moment(timeSelect.timeStart, "YYYY-MM-DD HH:mm:ss");
  const endTime = moment(timeSelect.timeEnd, "YYYY-MM-DD HH:mm:ss");
  useEffect(() => {
    if (timeSelect.timeStart && timeSelect.timeEnd) {
      if (moment.duration(endTime.diff(startTime)).days() >= 0) {
        setConfig({
          ...config,
          ...timeSelect,
          typeTime: 0,
        });
      } else {
        Modal.error({
          className: "wrapperModalErrConfigBanner",
          centered: true,
          width: 590,
          title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
          content: (
            <p style={{ fontSize: 20 }}>
              Thời gian bắt đầu và thời gian kết thúc không hợp lệ!
            </p>
          ),
        });
      }
    }
  }, [timeSelect.timeEnd, timeSelect.timeStart]);
  return (
    <Row className="headerPage">
      <h2 className="title">
        <TranslateText text={title} />
      </h2>
      <Row style={{ width: "100%" }} justify={"space-between"}>
        <Col className="mr-5">
          <InputSearchBox
            setText={(value) => {
              setValueSearch(value);
            }}
            width={435}
            placeholder={"Tìm kiếm theo tiêu đề"}
          />
        </Col>
        <Col
          className="mr-5"
          style={{
            flexGrow: "1",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <span
            style={{
              marginRight: "1.6rem",
              fontWeight: "400",
              color: "rgba(0, 0, 0, 1)",
            }}
            className="ml-5"
          >
            Thời gian
          </span>
          <SelectValue
            width={185}
            handleChange={(value) => {
              if (value !== 0) {
                const timeStart = "";
                const timeEnd = "";
                // if(value)
                setIsSelectTime(false);
                setConfig({ ...config, typeTime: value });
              } else {
                setIsSelectTime(true);
              }
            }}
            defaultValue={timeSelectSort[0].label}
            type={"selectGray mr-5"}
            optionsValue={timeSelectSort}
          />
          {isSelectTime ? (
            <>
              <span
                style={{
                  marginRight: "1.6rem",
                  fontWeight: "400",
                  color: "rgba(0, 0, 0, 1)",
                }}
              >
                Từ
              </span>
              <DatePicker
                // defaultValue={dayjs("2015/01/01", dateFormat)}
                onChange={(value) => {
                  if (value) {
                    setTimeSelect({
                      ...timeSelect,
                      timeStart: value.format("YYYY-MM-DD 00:00:00"),
                    });
                  } else {
                    setTimeSelect({
                      ...timeSelect,
                      timeStart: "",
                    });
                  }
                }}
                style={{
                  borderRadius: "33px",
                  background: "rgba(240, 240, 240, 1)",
                  color: "rgba(130, 130, 130, 1)",
                  height: "34px",
                }}
                format={dateFormat}
                className="mr-5"
              />
              <span
                style={{
                  marginRight: "1.6rem",
                  fontWeight: "400",
                  color: "rgba(0, 0, 0, 1)",
                }}
              >
                đến
              </span>
              <DatePicker
                // defaultValue={dayjs("2015/01/01", dateFormat)}
                style={{
                  borderRadius: "33px",
                  background: "rgba(240, 240, 240, 1)",
                  color: "rgba(130, 130, 130, 1)",
                  height: "34px",
                }}
                format={dateFormat}
                onChange={(value) => {
                  if (value) {
                    setTimeSelect({
                      ...timeSelect,
                      timeEnd: value.format("YYYY-MM-DD 23:59:59"),
                    });
                  } else {
                    setTimeSelect({
                      ...timeSelect,
                      timeEnd: "",
                    });
                  }
                  // setConfig({
                  //   ...config,
                  //   ...timeSelect,
                  //   typeTime: 0,
                  //   timeEnd: value.format("YYYY-MM-DD 23:59:59"),
                  // });
                }}
              />
            </>
          ) : null}
        </Col>
        <Col>
          <BaseButton
            content={"Excel"}
            handleClick={() => {
              dispatch(handleExport(config));
            }}
            typeBtn={"btnOrange"}
            width={127}
          />
        </Col>
      </Row>
    </Row>
  );
};

export default HeaderSort;
